import api from '../api';
import { saveAs } from '../../utils/saveFile';
import type {
  ComplianceAuditLogEntry,
  ComplianceAuditLogFilters,
} from '../../types/compliance';

// NOTE: the shared axios instance (`services/api.ts`) is configured with
// baseURL = config.API_URL, which already includes the `/api/v1` prefix.
// Paths here are relative to that prefix.
const BASE = '/compliance/audit';

export const complianceAuditService = {
  async list(filters?: ComplianceAuditLogFilters): Promise<ComplianceAuditLogEntry[]> {
    const { data } = await api.get<ComplianceAuditLogEntry[]>(BASE, { params: filters });
    return data;
  },
  async get(id: string): Promise<ComplianceAuditLogEntry> {
    const { data } = await api.get<ComplianceAuditLogEntry>(`${BASE}/${id}`);
    return data;
  },
  async exportCsv(filters?: ComplianceAuditLogFilters): Promise<void> {
    const today = new Date().toISOString().slice(0, 10);
    await saveAs(`compliance-audit-${today}.csv`, async () => {
      const response = await api.get(`${BASE}/export.csv`, {
        params: filters,
        responseType: 'blob',
      });
      return new Blob([response.data], { type: 'text/csv' });
    });
  },
};

export default complianceAuditService;
